import React from "react";
import { fetch } from '@fishx/rest';
import { set } from "dot-prop-immutable";
import { message } from '@whalecloud/fdx';
import CommonCodeDrawer from '@whalecloud/page-builder-base-components/components/CommonCodeDrawer';
import { getLocale } from "@utils/util";

const valueKey = 'data.formItemSettings';

const exampleUrl = {
  url: "/api/manage/recipientList.json"
}

const RemoteSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const {
    url = exampleUrl,
  } = formItemSettings;
  const onCreate = async (code: any) => {
    const { url, method = 'GET', params = {} } = code;
    try {
      const { data } = await fetch(url, {
        method,
        data: { ...params },
      });
      if (data) {
        const propName = `${valueKey}.treeData`;
        const newElement = set(element, propName, data);
        newElement.data.formItemSettings.autoInitialize = true;

        updateElement({
          element: newElement,
        });
        message.success(messages['PAGEBUIDER_MSG_SETTINGS_SUCCESS']);
      } else {
        message.error(messages['PAGEBUIDER_MSG_SETTINGS_FAIL']);
      }
    } catch (error) {
      message.error(error);
    }
  };

  const CodeDrawerProps = {
    value: JSON.stringify(url, null, '\t'),
    onClose: onCreate,
    title: `${messages['PAGEBUIDER_TITLE_REMOTE']}(JSON)`,
    buttonText: messages['PAGEBUIDER_TITLE_REMOTE']
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <CommonCodeDrawer {...CodeDrawerProps} />
    </div>
  );
};

export default RemoteSettings;
